"use strict";
/**
 * Created by Ning Jiang on 4/18/2017.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FringeSymbolsController = void 0;
const EventHandler_1 = require("../../core/event/EventHandler");
const GameConfig_1 = require("../../core/gameconfig/GameConfig");
const Reels_1 = require("../../core/reel/reelarea/Reels");
const ReelStopPresentationController_1 = require("../../core/reelstoppresentation/ReelStopPresentationController");
const ScreenEvent_1 = require("../../core/screen/event/ScreenEvent");
const SpinEvent_1 = require("../../core/spin/event/SpinEvent");
const gsap_1 = require("gsap");
class FringeSymbolsController extends ReelStopPresentationController_1.ReelStopPresentationController {
    constructor(index, config) {
        super(index, "FringeSymbolsReelStopPresentation");
        this._config = config;
    }
    addFeatureEventHandlers() {
        EventHandler_1.EventHandler.addEventListener(this, ScreenEvent_1.ScreenEvent.GAME_READY, (event) => this.onGameReady());
        EventHandler_1.EventHandler.addEventListener(this, SpinEvent_1.SpinEvent.BEFORE_START, (event) => this.onBeforeSpinStart(event.params[0]));
    }
    onGameReady() {
        for (let i = 0; i < GameConfig_1.GameConfig.instance.REELS_NUM; i++) {
            this.setFringeSymbols(i, 0, true);
        }
    }
    onBeforeSpinStart(activeReels) {
        for (let i = 0; i < GameConfig_1.GameConfig.instance.REELS_NUM; i++) {
            // Do not reset if the reel is inactive for the next spin.
            if (!activeReels[i]) {
                continue;
            }
            const topSymbol = Reels_1.Reels.getSymbol(i, -1);
            if (topSymbol) {
                topSymbol.changeState({
                    state: GameConfig_1.GameConfig.instance.SYMBOL_STATES.normal
                });
            }
            const bottomSymbol = Reels_1.Reels.getSymbol(i, GameConfig_1.GameConfig.instance.SYMBOLS_NUM_IN_REEL[2]);
            if (bottomSymbol) {
                bottomSymbol.changeState({
                    state: GameConfig_1.GameConfig.instance.SYMBOL_STATES.normal
                });
            }
        }
    }
    onReelBounce(data) {
        this.setFringeSymbols(data.reelId, (data.fastSpin || data.quickStop) ? this._config.duration / 2 : this._config.duration);
    }
    // The inactive reel doesn't send bounce event.
    onReelSpinStopped(data) {
        if (!data.active) {
            this.dispatchCompleteEvent(data.reelId);
        }
    }
    setFringeSymbols(reelId, duration, init = false) {
        const timeline = new gsap_1.TimelineLite({
            paused: true,
            onComplete: () => {
                if (!init) {
                    this.dispatchCompleteEvent(reelId);
                }
            }
        });
        const topSymbol = Reels_1.Reels.getSymbol(reelId, -1);
        if (topSymbol) {
            timeline.add(topSymbol.changeState({
                state: this._config.state,
                fadeInDuration: duration
            }), 0);
        }
        const bottomSymbol = Reels_1.Reels.getSymbol(reelId, GameConfig_1.GameConfig.instance.SYMBOLS_NUM_IN_REEL[2]);
        if (bottomSymbol) {
            timeline.add(bottomSymbol.changeState({
                state: this._config.state,
                fadeInDuration: duration
            }), 0);
        }
        timeline.play();
    }
}
exports.FringeSymbolsController = FringeSymbolsController;
//# sourceMappingURL=FringeSymbolsController.js.map